import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export const TarifasEditor = () => {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/tarifas").then((r) => setD(r.data));
  }, []);
  if (!d) return <p className="text-sm text-slate-400">Cargando…</p>;
  const setT = (i, k, v) => setD({ ...d, tarifas: d.tarifas.map((t, j) => (j === i ? { ...t, [k]: v } : t)) });
  const setC = (k, v) => setD({ ...d, clinica: { ...d.clinica, [k]: v } });
  const save = async () => {
    const r = await api.put("/tarifas", { tarifas: d.tarifas.map((t) => ({ ...t, precio: Number(t.precio || 0) })), clinica: d.clinica });
    setD(r.data);
    toast.success("Precios guardados");
  };
  const inp = "h-8 rounded-md border border-slate-200 px-2 text-sm bg-white";
  return (
    <div className="space-y-4" data-testid="tarifas-editor">
      <table className="w-full text-sm"><tbody className="divide-y divide-slate-100">
        {d.tarifas.map((t, i) => (
          <tr key={t.id || i} data-testid={`tarifa-row-${i}`}>
            <td className="py-1 pr-2"><input className={`${inp} w-full`} value={t.nombre} onChange={(e) => setT(i, "nombre", e.target.value)} data-testid={`tarifa-nombre-${i}`} /></td>
            <td className="py-1 w-28"><input type="number" className={`${inp} w-full text-right`} value={t.precio} onChange={(e) => setT(i, "precio", e.target.value)} data-testid={`tarifa-precio-${i}`} /></td>
            <td className="py-1 w-8"><button onClick={() => setD({ ...d, tarifas: d.tarifas.filter((_, j) => j !== i) })} className="text-slate-400 hover:text-rose-600" data-testid={`tarifa-del-${i}`}><X className="h-4 w-4" /></button></td>
          </tr>
        ))}
      </tbody></table>
      <Button variant="outline" size="sm" onClick={() => setD({ ...d, tarifas: [...d.tarifas, { nombre: "", precio: 0, sug: "" }] })} data-testid="tarifa-add"><Plus className="h-4 w-4 mr-1" />Añadir precio</Button>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        <input className={inp} value={d.clinica.razon_social || ""} onChange={(e) => setC("razon_social", e.target.value)} placeholder="Razón social" data-testid="clinica-razon" />
        <input className={inp} value={d.clinica.cif || ""} onChange={(e) => setC("cif", e.target.value)} placeholder="CIF" data-testid="clinica-cif" />
        <input className={inp} value={d.clinica.email || ""} onChange={(e) => setC("email", e.target.value)} placeholder="Email" data-testid="clinica-email" />
        <input className={inp} value={d.clinica.web || ""} onChange={(e) => setC("web", e.target.value)} placeholder="Web" data-testid="clinica-web" />
        <input className={`${inp} md:col-span-2`} value={d.clinica.pie || ""} onChange={(e) => setC("pie", e.target.value)} placeholder="Texto al pie del presupuesto (opcional)" data-testid="clinica-pie" />
      </div>
      <Button onClick={save} className="bg-[#1E3A8A] hover:bg-[#1E40AF]" data-testid="tarifas-save">Guardar precios</Button>
    </div>
  );
};
